//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"AspectRatio",1,0],[0,"FileBrowser",1,0],[0,"LatitudeScale",1,0],[0,"LongitudeScale",1,0],[0,"NameString",1,0],[0,"NormalVector",1,"Direction",0],[0,"Scale",1,0],[0,"TextureSpaceEnum",1,0],[0,"TexturedToggle",1,0],[0,"UScale",1,0],[0,"UpVector",1,"Direction",0],[0,"VScale",1,0]],[[["nColorPicker"],"GetColorPicker",{R_:{colorPicker:""}},0,0],[["colorPicker"],"SetColorPicker",{},1,0],[[],"SaveMaterialsButton",{},0,0],[[],"ExportXMLButton",{},0,0]],[]];
SPLM.Display.IrayPlusSimpleMaterialEditorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.IrayPlusSimpleMaterialEditorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.IrayPlusSimpleMaterialEditorBuilder.TextureSpace = Object.freeze({
    "Box" : "Box", "Planar" : "Planar", "Cylindrical" : "Cylindrical", "Spherical" : "Spherical", "UVMap" : "UVMap"});

export default SPLM;